import React from "react";
import { ReactComponent as MyProfileClientIcon } from "icons/user-icon.svg";
import { ReactComponent as CompanyProfileIcon } from "icons/suitcase.svg";
import { FiEye } from "react-icons/fi";
import { useCurrentCompany } from "hooks/auth";
import { isBidder, isProcurerNBidder } from "utils/helpers";
import { BaseMemberPaths } from "newui/utils/navigation/navigation.types";
import { AppMenuItem } from "./AppMenuItem/AppMenuItem";
import { SettingsExpandableMenu } from "./SettingsExpandableMenu";
import { AppMenuHeader } from "./AppMenuHeader";

interface AppMenuCommonBottomItemsProps {
  exactProfileLinks?: boolean;
  isCollapsed: boolean;
  paths: BaseMemberPaths;
  onNavigate?: () => void;
}

export const AppMenuCommonBottomItems: React.FC<AppMenuCommonBottomItemsProps> = ({
  isCollapsed,
  paths,
  exactProfileLinks = false,
  onNavigate,
}) => {
  const currentCompany = useCurrentCompany();
  const canPreviewProfile = isBidder(currentCompany) || isProcurerNBidder(currentCompany);

  return (
    <>
      {canPreviewProfile && (
        <AppMenuItem
          name="Preview Profile"
          icon={<FiEye size={24} />}
          link={`/${paths.previewProfile}`}
          type="tab"
          isCollapsed={isCollapsed}
          testId="preview-profile"
          tourName="PreviewProfile"
        />
      )}
      <AppMenuItem
        name="Company Profile"
        icon={<CompanyProfileIcon />}
        link={paths.companyProfile.information}
        exactLink={exactProfileLinks}
        isCollapsed={isCollapsed}
        testId="company-profile"
        tourName="CompanyProfile"
        onNavigate={onNavigate}
      />

      <AppMenuItem
        name="My Profile"
        icon={<MyProfileClientIcon />}
        link={paths.myProfile}
        exactLink={exactProfileLinks}
        isCollapsed={isCollapsed}
        testId="my-profile"
        tourName="MyProfile"
        onNavigate={onNavigate}
        // PRO-737: the one destination a user with no RBAC standing may reach,
        // and where their limited-access notice and contact list live.
        alwaysEnabled
      />
      <SettingsExpandableMenu
        isCollapsed={isCollapsed}
        paths={paths}
        onNavigate={onNavigate}
      />
    </>
  );
};
